import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {fetchPedidosColores,fetchPedidosUso} from '../../../../actions';
import { FETCH_PEDIDOS_COLORES,FETCH_PEDIDOS_USO,FETCH_PROFORMA_COLOR } from '../../../../actions';

const UsoYcolor = (props) =>(
    <section className='fdv-section tab-pane active' id='coloruso'>
    <header className='fdv-section-head'>
      <h5 className='fdv-section-title'>Color y uso</h5>
    </header>
    <div className='row'>


        <div className='col-sm-3'>
          <label className='labelInfo'>Color(es)
            </label><p>
            {
            props.listaColores.map((entity)=>{
              return entity.desColorFabricaVeh + ',  ';

            }
          )
            }
            </p>
        </div>

      <div className='col-sm-3'>
        <label className='labelInfo'>Uso
          </label>
        <p>{props.listaPedidoUso.map((entity)=>{

            return entity.desUsoVeh;

        }
        )}</p>
      </div>
    </div>
  </section>
);

class TabUsoYcolor extends Component{
  constructor(props){
    super(props);
    this.state={
      listaColores:[],
      listaPedidoUso:[]
    }
  }

  componentDidMount(){

    const promises = [];
    this.props.loading('block');
    promises.push(this.props.fetchPedidosColores(this.props.fdvID,this.props.selectNurPedido));
    promises.push(this.props.fetchPedidosUso(this.props.fdvID, this.props.selectPedido));

    Promise.all(promises)
            .then((results) => {
              this.setState({
                  listaColores:results.filter(element => element.type === FETCH_PEDIDOS_COLORES).map(row => row.payload.data.colorPedidoList)[0],
                  listaPedidoUso:results.filter(element => element.type === FETCH_PEDIDOS_USO).map(row => row.payload.data.usoPedidoLista)[0]
                });
              this.props.loading('');    
            });

  }

  render(){
    return(

      this.state.listaColores.length === 0?(
        <div className='tableWrapper'>
        <table className='table table-hover '>
          <tr>
            <td> <p style={{textAling:'center'}}>El pedido no tiene colores asignados !!</p></td>
          </tr>
        </table>
        </div>
      ):(
        <UsoYcolor
        listaColores= {this.state.listaColores}
        listaPedidoUso = {this.state.listaPedidoUso}
        />
      )
    )
  }





}
function mapStateToProps(state) {
  return {
    equiposCortesia: state.equiposCortesia,

  }
}

export default withRouter(
  connect(mapStateToProps,{
    fetchPedidosColores,
    fetchPedidosUso
  })
  (TabUsoYcolor));



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetallePedido/ItemsDetalle/UsoYcolor.js